import { html } from 'lit';
import { createElement, Paperclip } from 'lucide';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-paperclip')
export class PdsIconPaperclip extends PdsIcon {
  createIconElement(): SVGElement {
    return createElement(Paperclip);
  }

  render() {
    return html`${this.icon}`;
  }
}
